import React, { Component } from 'react'
import Loader from "../../../components/elements/loader/Loader";
import MaterialIcon, { colorPalette } from 'material-icons-react';
import Rank from 'constants/Rank';
import HttpClient from "../../../utils/HttpClient/HttpClient";
import API_URL from "../../../utils/HttpClient/apiRest";
import TreeFormContent from "./TreeFormContent";

export default class TreeFormDesktop extends Component {


    addNewTeam = () => {
        alert("addNewTeam");
    }

    render() {

        return (
            <div className="desktop-tree-form" style={{ pointerEvents: "all" }}>
                <div className={`${this.props.containerClass}`}>

                    <div className={`tree-form default-drawer-bg ${this.props.openClass}`}>
                        <TreeFormContent
                            isDesktop
                            loaded={this.props.loaded}
                            loading={this.props.loading}
                            interestedListOnly={this.props.interestedListOnly}
                            selectedUser={this.props.selectedUser}
                            empty={this.props.empty}
                            details={this.props.details} />
                    </div>
                    <button type="button" onClick={() => this.props.onOpenClick()}
                        className={`btn rounded-circle open-btn ${this.props.pulseClass}`}>
                        <MaterialIcon size="25px" color="white" icon={this.props.btnIcon} />
                    </button>

                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Tree/TreeForm/TreeFormDesktop.jsx